import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './style/App.scss';

// Components
import Navigation from './components/navigation/Navigation';
import Music from './components/music/Music';
import Software from './components/software/Software';
import Landing from './components/landing/Landing';

const AppContent = () => {
  const location = useLocation();
  const showNav = location.pathname !== '/';

  return (
    <div className="App">
      {showNav && <Navigation />}
      <div className="page-transition-wrapper">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Landing />} />
          <Route path="/music" element={<Music />} />
          <Route path="/software" element={<Software />} />
        </Routes>
      </div>
    </div>
  );
};

class App extends React.Component {
  render() {
    return <AppContent />;
  }
}

export default App;
